import { render, staticRenderFns } from "./DivaltoCodesForm.vue?vue&type=template&id=8a1286ea&scoped=true"
import script from "./DivaltoCodesForm.vue?vue&type=script&lang=js"
export * from "./DivaltoCodesForm.vue?vue&type=script&lang=js"
import style0 from "./DivaltoCodesForm.vue?vue&type=style&index=0&id=8a1286ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1286ea",
  null
  
)

export default component.exports